// B-036 — the CSV export button, with the Alt+E binding built in.
//
// Alt+E works by App.tsx doing querySelector('[data-shortcut="export"]').click().
// That means the shortcut only reaches a page if someone remembered to hand-copy BOTH
// magic strings — data-shortcut="export" and title="Alt+E" — onto its CSV button.
// Twenty pages carried that copy-paste, and any new report page that forgot it lost
// Alt+E silently: no error, no warning, the key just does nothing on that one screen.
//
// Using this component makes the binding structural instead of remembered.
//
//   <ExportCsvButton onClick={downloadCsv} disabled={!data} />
//
// The `data-shortcut` attribute stays the mechanism (App.tsx is unchanged), but it now
// has exactly one definition rather than twenty.

import { Button, type ButtonProps } from '@/components/primitives/Button';

export interface ExportCsvButtonProps extends Omit<ButtonProps, 'variant' | 'children'> {
  /** Button text. Defaults to "CSV" — the label every report already used. */
  label?: string;
  /** Override the variant in the rare place a primary export button is wanted. */
  variant?: ButtonProps['variant'];
}

export function ExportCsvButton({ label = 'CSV', variant = 'ghost', ...rest }: ExportCsvButtonProps) {
  return (
    <Button
      variant={variant}
      // These two are the whole point — never pass them by hand again.
      data-shortcut="export"
      title="Alt+E"
      {...rest}
    >
      {label}
    </Button>
  );
}
